const React = require("react")
const svgLogo = require("shared/assets/svg/LogoAlgar.svg")
const svgSair = require("shared/assets/svg/sair.svg")

module.exports = {
  Logo: () => <img src={svgLogo} alt="Algar logo" />,
  Sair: () => <img src={svgSair} alt="Sair" />
}



// WEBPACK FOOTER //
// ./src/shared/skin/icons/header/index.js